const RECIPIENT_TYPE = Object.freeze({
    DONOR: 'donor',
    AMBASSADOR: 'ambassador',
});

module.exports = {
    RECIPIENT_TYPE,
};
